import { AwsRumConfig } from 'aws-rum-web';

const RUM = window.CONFIGS?.RUM ?? ({} as Window['CONFIGS']['RUM']);

if (!window.CONFIGS?.RUM) {
    // eslint-disable-next-line no-console
    console.warn(
        'window.CONFIGS.RUM is missing — RUM configuration failed to load (check /.configs/configs.js). ' +
            'AWS RUM will be disabled for this session.'
    );
}

export const awsRumConfig: AwsRumConfig = {
    sessionSampleRate: RUM.VITE_RUM_SESSION_SAMPLE_RATE,
    identityPoolId: RUM.VITE_RUM_IDENTITY_POOL_ID,
    endpoint: RUM.VITE_RUM_ENDPOINT,
    telemetries: RUM.VITE_RUM_TELEMETRIES,
    allowCookies: RUM.VITE_RUM_ALLOW_COOKIE,
    enableXRay: RUM.VITE_RUM_ENABLE_XRAY,
    signing: RUM.VITE_RUM_SIGNING, // If you have a public resource policy and wish to send unsigned requests please set this to false
    sessionEventLimit: RUM.VITE_RUM_SESSION_EVENT_LIMIT,
    enableRumClient: RUM.VITE_RUM_ENABLE_RUM_CLIENT,
};

export const APPLICATION_ID: string = RUM.VITE_RUM_APP_ID;
export const APPLICATION_VERSION: string = RUM.VITE_RUM_APPLICATION_VERSION;
export const APPLICATION_REGION: string = 'us-east-1';
